import { BasicTab } from "./BaseTab";

export const SourcesTab = () => {
  return (
    <BasicTab title="Sources" tooltip="">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          overflow: "hidden"
        }}
      >
        <p
          style={{
            margin: 0,
            padding: 0,
            width: "100%",
            fontSize: "13px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            userSelect: "none"
          }}
        >
          Sources
        </p>
      </div>
    </BasicTab>
  );
};
